// Imports
  // React
  import React, { useContext} from 'react'
  // Context
  import { CartContext } from "../context/CartContext"
  // Components
  import CartItemCardCounter from "./CartItemCardCounter"
  



// rafce

const CartItemCard = ({item}) => {

  // Functions
  const { getItem } = useContext(CartContext);

    let itemInCart = getItem(item.name);
  
    // Counter
    let updatedCounter = 0;
    if(itemInCart) {
      updatedCounter = itemInCart.qty
    }

    // Stock
    let updatedStock = item.stock;
    if(itemInCart) {
      updatedStock = item.stock - itemInCart.qty
    }

  return (
    <div className="cart-item-card">
      <h2>{item.name}</h2>
      <div>$ {item.price.toFixed(2)}</div>
      <CartItemCardCounter item={item} counter={updatedCounter} stock={updatedStock} />
    </div>
  )
}

export default CartItemCard